import { useLocation } from '@reach/router'
import { useMobile } from 'src/hooks/useMobile'
import { redirectToAccountOrLogin } from 'src/utils/redirectToAccountUrl'
import { checkEnviromentIsB2B } from 'src/utils/checkEnviroment'
import { makeEventTrack, sendEvent } from 'src/utils/restructure/analytics'
import { setCookie } from 'src/utils/cookies'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

const LoggedOutContent = () => {
  const { pageData } = useGlobalContext()
  const { isMobile } = useMobile()
  const location = useLocation()
  const isB2B = checkEnviromentIsB2B()
  const standardObject = getStandardObject(pageData)

  function handleClick(e: React.MouseEvent<HTMLElement>) {
    setCookie('loginURL', window.location.href)

    const trackEvent = makeEventTrack({
      eventPage: location.pathname === '/' ? 'home' : location.pathname,
      eventAction: e.currentTarget.ariaLabel ?? '',
    })

    sendEvent(trackEvent)

    dispatchAmplitudeEvent({
      eventName: 'Account Process Entered',
      eventData: {
        ...standardObject,
      },
    })
  }

  return (
    <div className="flex gap-6 flex-col font-normal font-inter">
      <p className="text-sm text-restructure-primary">
        Faça login para consultar o seu cashback e acompanhar seu pedido :)
      </p>

      <a
        href={redirectToAccountOrLogin(isB2B)}
        aria-label={`Fazer login${isMobile ? ' - mobile' : ''}`}
        className="w-full min-w-[182px] flex items-center justify-center h-12 bg-black text-white font-semibold font-inter text-body-md-link restructure-tablet:text-sm rounded-round restructure-tablet:h-8"
        onClick={(e) => handleClick(e)}
        data-testid="login-dropdown-login-button"
      >
        Fazer login
      </a>
    </div>
  )
}

export default LoggedOutContent
